// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { getPublicSiteUrl } = require('core/apiURLBuilder');

// @constants
const { BROKER_PLAN_LEGAL_DOCUMENT_MORNING_STAREXT_SECURTY_DETAILS } = require('constants/index');

const {
    BROKER_PLAN_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH_SUCCESS,
    BROKER_PLAN_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH_ERROR,
    BROKER_PLAN_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH,
    BROKER_PLAN_LEGAL_DOCUMENT_SUBSCRIPTION_NEWSLETTER_FETCH_SUCCESS
} = require('constants/actionTypes');

const fetchMorningstarextSuccess = (response, planDgsCode) => (dispatch, getState) => dispatch({
    type: BROKER_PLAN_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH_SUCCESS,
    payload: { response: response, planDgsCode: planDgsCode, originCountry: getState().profile.get('originCountry') }
});

const fetchMorningstarextError = (error) => (dispatch) => dispatch({
    type: BROKER_PLAN_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH_ERROR,
    payload: { error }
});

const fetchMorningstarext = (secId, planDgsCode) => (dispatch) => {
    dispatch({
        type: BROKER_PLAN_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH,
        payload: {}
    });

    const url = apiURLBuilder.getURL('morningstarextSecurityDetails', {
        productMorningstarextSecurityDetails: BROKER_PLAN_LEGAL_DOCUMENT_MORNING_STAREXT_SECURTY_DETAILS,
        secId
    });

    APIGet(dispatch, url, {}).then(
        (response) => dispatch(fetchMorningstarextSuccess(response, planDgsCode)),
        (error) => dispatch(fetchMorningstarextError(error))
    );
};

const fetchSubscriptionNewsletter = (planDgsCode) => (dispatch) => {
    const publicSiteUrl = getPublicSiteUrl();
    const url = `${publicSiteUrl}/assets/static/pdf/planes/boletines/${planDgsCode}.pdf`;

    dispatch({
        type: BROKER_PLAN_LEGAL_DOCUMENT_SUBSCRIPTION_NEWSLETTER_FETCH_SUCCESS,
        payload: { url }
    });
};

const fetchLegalDocuments = (planDgsCode, secId) => (dispatch) => {
    dispatch(fetchMorningstarext(secId, planDgsCode));
    dispatch(fetchSubscriptionNewsletter(planDgsCode));
};

module.exports = {
    fetchMorningstarext,
    fetchSubscriptionNewsletter,
    fetchLegalDocuments
};
